import React, {useEffect, useState} from 'react';
import {Portlet, PortletBody, PortletFooter, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Form} from "react-bootstrap";
import LoadingButton from "../../base/components/loadingButton";
import axios from "../../../helpers/axios";
import SearchForm from "./SearchForm";
import _ from "lodash";
import {Link, useParams} from "react-router-dom";
import {SalesRegisterEditRoute} from "../../routesConstants";
import numberFormat from "../../../helpers/numberFormat";
import SaleTable from "./saleTable";
import DeletedBtn from "./deletedBtn";
import sayError from "../../../helpers/sayError";
import moment from "moment";
import 'moment/locale/ru';
import PaymentsTable from "./paymentsTable";
import AccountedRecordsRow from "./accountedRecordsRow";
import AddRowsModal from "./addRowsModal";
import {useForm} from "react-hook-form";
import CustomDatePicker from "../../base/components/forms/customDatePicker";
import {useSelector} from "react-redux";
import BlockUi from "@availity/block-ui";
import {Helmet} from "react-helmet";
import Button from "react-bootstrap/Button";

const isBalanceRow = (row) => /^(Долг|Переплата) с реестра от /.test(row?.operation || '')
const KASPI_FEE_OPERATION = 'Каспи пей +1%'

const pinBalanceRows = (rows) => {
  if (!Array.isArray(rows)) return rows
  return [
    ...rows.filter(isBalanceRow),
    ...rows.filter(row => !isBalanceRow(row))
  ]
}

const formatTitlePeriod = (start, end) => {
  const from = moment(start, 'DD.MM.YYYY', true)
  const to = moment(end, 'DD.MM.YYYY', true)
  if (!from.isValid() || !to.isValid()) return ''
  return `${from.format('DD.MM')}-${to.format('DD.MM.YYYY')}`
}

const formatHeaderPeriod = (start, end) => {
  const from = moment(start, 'DD.MM.YYYY', true)
  const to = moment(end, 'DD.MM.YYYY', true)
  if (!from.isValid() || !to.isValid()) return null
  return `c ${from.locale('ru').format('D MMMM YYYY')} г. по ${to.locale('ru').format('D MMMM YYYY')} г.`
}

const SaleRegister = ({edit, dataBase, cb, saving, buyerId}) => {
  const {id} = useParams();

  const [data, setData] = useState(dataBase)
  const [description, setDescription] = useState(dataBase?.description || '')
  const [options, setOptions] = useState()

  const [loading,setLoading] = useState(false)
  const [addRowsOpen, setAddRowsOpen] = useState(false)
  const [showCol,setShowCol] = useState({name:false, krs:false, oneCCodes: false})
  const [realPeriod, setRealPeriod] = useState(() => (
    edit && dataBase?.start && dataBase?.end
      ? {start: dataBase.start, end: dataBase.end}
      : {start: '', end: ''}
  ))
  const realDateForm = useForm()

  useEffect(() => {
    if (options) return
    if (!dataBase?.tableData?.tableData) {
      setData(dataBase)
      return
    }
    setData({
      ...dataBase,
      tableData: {
        ...dataBase.tableData,
        tableData: pinBalanceRows(dataBase.tableData.tableData)
      }
    })
  }, [dataBase, options]);

  const periodStart = realPeriod.start || options?.start || data?.start || ''
  const periodEnd = realPeriod.end || options?.end || data?.end || ''
  const counterparty = data?.tableData?.header?.counterparty
  const periodLabel = formatTitlePeriod(periodStart, periodEnd)
  const pageTitle = counterparty && periodLabel ? `Реестр ${counterparty} ${periodLabel}` : ''

  const getValues = (dataF, keepRealPeriod)=>{
    console.log(dataF)
    setLoading(true)
    setOptions(dataF)
    axios.post('/api/salesRegister/getRegister', edit && id ? {...dataF, excludeId: id} : dataF)
      .then(({data})=>{
        data.createTime = moment().format('DD.MM.YYYY HH:mm')
        console.log('from base',data)
        data.tableData = pinBalanceRows(_.sortBy(data.tableData, (r)=>moment(r.issueDate,'DD.MM.YYYY').unix()))
        const period = keepRealPeriod && realPeriod.start && realPeriod.end
          ? realPeriod
          : {start: dataF.start, end: dataF.end}
        const nextStart = formatHeaderPeriod(dataF.start, dataF.start) ? dataF.start : ''
        const nextEnd = formatHeaderPeriod(dataF.end, dataF.end) ? dataF.end : ''
        if (!keepRealPeriod && nextStart && nextEnd) {
          setRealPeriod({start: nextStart, end: nextEnd})
          realDateForm.setValue('realStart', nextStart)
          realDateForm.setValue('realEnd', nextEnd)
        }
        const headerDate = formatHeaderPeriod(period.start, period.end)
        if (headerDate) data.header = {...data.header, date: headerDate}
        setData(prev => ({
          ...(edit ? prev : {}),
          payments: data.payments,
          tableData: data,
          start: period.start,
          end: period.end,
        }))
        !edit && window.history.pushState({}, null, `/salesRegister/create?start=${dataF.start}&end=${dataF.end}&id=${dataF.buyerId}`)
      })
      .finally(()=>setLoading(false))
  }
  const saveRegister = (alert) =>{
    console.log("before saving",data)
    if(data.tableData?.prevRegister){
      data.tableData.prevRegister = data.tableData.prevRegister.id
    }

    const periodStartToSave = realPeriod.start || options?.start || data?.start || dataBase?.start
    const periodEndToSave = realPeriod.end || options?.end || data?.end || dataBase?.end
    const send = !edit ?{
      ...options,
      ...data,
      start: periodStartToSave,
      end: periodEndToSave,
      description
    }:{
      ...data,
      ...(periodStartToSave && periodEndToSave ? {start: periodStartToSave, end: periodEndToSave} : {}),
      description
    }
    send.alert = alert
    console.log(send)
    cb && cb(send)
  }
  const addPrevBalance = () => {
    const prev = data?.tableData?.prevRegister
    const total = Number(prev?.summ)
    if (!prev || !total) return
    const issueDate = prev.end
    const operation = `${total < 0 ? "Переплата" : "Долг"} с реестра от ${issueDate}`
    const identifier = `D${issueDate}${total}`
    setData(prevData => {
      const rows = prevData?.tableData?.tableData || []
      if (rows.some(row => row.identifier === identifier || row.operation === operation)) return prevData
      return {
        ...prevData,
        tableData: {
          ...prevData.tableData,
          tableData: [{
            identifier,
            operation,
            pax: "",
            BSO: "",
            route: "",
            total,
            flightDate: "",
            issueDate,
            from1C: false
          }, ...rows]
        }
      }
    })
  }
  const addKaspiFee = () => {
    setData(prev => {
      const rows = prev?.tableData?.tableData || []
      const baseRows = rows.filter(row => row.operation !== KASPI_FEE_OPERATION)
      const debt = _.sumBy(baseRows, row => Number(row.total) || 0)
      const fee = Math.round(debt * 0.01)
      return {
        ...prev,
        tableData: {
          ...prev.tableData,
          tableData: [...baseRows, {
            identifier: 'KASPI1',
            operation: KASPI_FEE_OPERATION,
            pax: '',
            BSO: '',
            route: '',
            total: fee,
            flightDate: '',
            issueDate: '',
            from1C: false,
          }]
        }
      }
    })
  }
  const addExtraRows = (rows) => {
    setData(prev => {
      const existing = prev?.tableData?.tableData || []
      const existingIds = new Set(existing.map(row => row.identifier).filter(Boolean))
      const incoming = rows
        .filter(row => !row.identifier || !existingIds.has(row.identifier))
        .map(row => ({...row}))
      if (!incoming.length) return prev
      const next = [...existing]
      incoming.forEach(item => {
        const itemDate = moment(item.issueDate, 'DD.MM.YYYY', true)
        const neededIndex = _.findIndex(next, row => {
          if (isBalanceRow(row)) return false
          const rowDate = moment(row.issueDate, 'DD.MM.YYYY', true)
          return rowDate.isValid() && itemDate.isValid() && rowDate.isAfter(itemDate)
        })
        if (neededIndex === -1) next.push(item)
        else next.splice(neededIndex, 0, item)
      })
      return {
        ...prev,
        tableData: {
          ...prev.tableData,
          tableData: pinBalanceRows(next)
        }
      }
    })
  }
  const onRealDateChange = (field, date) => {
    if (!date) return
    const formatted = moment(date).format('DD.MM.YYYY')
    const next = {...realPeriod, [field]: formatted}
    const headerDate = formatHeaderPeriod(next.start, next.end)
    setRealPeriod(next)
    if (!headerDate) return
    setData(prev => {
      if (!prev?.tableData?.header) return prev
      return {
        ...prev,
        tableData: {
          ...prev.tableData,
          header: {...prev.tableData.header, date: headerDate}
        }
      }
    })
  }
  const markPaid = () =>{
    setLoading(true)
    axios.post('/api/salesRegister/markPaid/'+id)
      .then(()=>{
        window.location.reload()
      })
      .catch(sayError)
      .finally(()=>setLoading(false))}
  console.log('dataBase',dataBase)
  console.log('data',data)

  useEffect(() => {
    if(!edit){
      console.log("edit" , edit)
      const handlePrint = async (event) => {
        console.log('handlePrint start')
        const isPrint =
          (event.ctrlKey || event.metaKey) &&
          event.key.toLowerCase() === 'p';

        if (!isPrint) return;
          event.preventDefault();

          // Сначала сохраняем
          console.log('тут будет сохранение')
          saveRegister(true)
          // await saveForm();

          // Потом открываем печать
          window.print();

      };

      window.addEventListener('keydown', handlePrint);

      return () => {
        window.removeEventListener('keydown', handlePrint);
      };
    }
  }, [data, realPeriod]);

  console.log('data.accountedRecords',data && data.tableData.accountedRecords)
  return (
    <div id={'main'}>
      {pageTitle && <Helmet><title>{pageTitle}</title></Helmet>}
      <Portlet>
        <PortletHeader title={'Краткий реестр продаж'} toolbar={<PortletHeaderToolbar>
          {edit && data && <div className={'d-flex gap-2 align-items-center'}>
            {dataBase.isPaid && <h5 className={'text-success m-0'}>Оплачено</h5>}
            {/*<LoadingButton title={dataBase.isPaid ?'Оплачено':'Оплатить'}*/}
            {/*               disabled={true}*/}
            {/*               variant={dataBase.isPaid ?'success':'primary'}*/}
            {/*               loading={loading}*/}
            {/*               onClick={markPaid}/>*/}
            <DeletedBtn isDeleted={dataBase.isDeleted} buyerId={buyerId}/>
          </div>}
        </PortletHeaderToolbar>}/>
        <PortletBody>
          <SearchForm onSubmit={getValues}
                      loading={loading}
                      info={data?.tableData}
                      edit={edit}
                      buyerId={buyerId || dataBase?.buyerId}
                      initialStart={dataBase?.start}
                      initialEnd={dataBase?.end}/>
          {data && periodStart && periodEnd &&
            <div className={'d-flex align-items-end gap-2 mt-4'}>
              <div style={{width: 230}}>
                <CustomDatePicker formController={realDateForm}
                                  label={"Реальная дата реестра с"}
                                  value={periodStart}
                                  name={`realStart`}
                                  cb={date => onRealDateChange('start', date)}/>
              </div>
              <div style={{width: 230}}>
                <CustomDatePicker formController={realDateForm}
                                  label={"Реальная дата реестра по"}
                                  value={periodEnd}
                                  name={`realEnd`}
                                  cb={date => onRealDateChange('end', date)}/>
              </div>
            </div>}
          <BlockUi blocking={loading}>
            {data ?
              <>
                <div className={'d-flex gap-2'}>
                  <Form.Label className={'d-flex align-items-center gap-2 mt-2'}>
                    <input
                      defaultChecked={showCol.name}
                      onChange={() => setShowCol(old => ({...old, name: !old.name}))}
                      type={"checkbox"}
                    />{" "}
                    Скрыть колонку "Документ/Операция"
                  </Form.Label>
                  <Form.Label className={'d-flex align-items-center gap-2 mt-2'}>
                    <input
                      defaultChecked={showCol.name}
                      onChange={() => setShowCol(old => ({...old, krs: !old.krs}))}
                      type={"checkbox"}
                    />{" "}
                    Показать колонки "КРС"
                  </Form.Label>
                  <Form.Label className={'d-flex align-items-center gap-2 mt-2'}>
                    <input
                      defaultChecked={showCol.oneCCodes}
                      onChange={() => setShowCol(old => ({...old, oneCCodes: !old.oneCCodes}))}
                      type={"checkbox"}
                    />{" "}
                    Показать код 1с
                  </Form.Label>

                </div>
                {data?.tableData?.info?.length > 0 && <div className={'text-warning mt-2'}>
                  {data.tableData.info.map((message, index) => <div key={index}>{message}</div>)}
                </div>}
                {(data?.tableData?.prevRegister && (!edit || options)) && <div>
                  В базе найдет реестр для <Link to={SalesRegisterEditRoute + data.tableData.prevRegister.id}
                                                 target={'_blank'}>{data.tableData.prevRegister.counterparty} на
                  сумму: {numberFormat(data.tableData.prevRegister.summ)} KZT</Link>
                  {!!data.tableData.prevRegister.summ && !data.tableData.tableData?.some(row => row.identifier === `D${data.tableData.prevRegister.end}${data.tableData.prevRegister.summ}`) &&
                    <button type="button"
                            className="btn btn-sm btn-outline-primary ml-2"
                            onClick={addPrevBalance}>
                      Добавить в текущий реестр
                    </button>}
                  <br/>
                  Период: {data.tableData.prevRegister.start} - {data.tableData.prevRegister.end}<br/>
                  Оплачен: {data.tableData.prevRegister.isPaid ? <>
                    <i className="fa fa-check-circle text-success"/> {}
                  </> :
                  <i className="fa fa-times-circle text-danger"/>}
                </div>}
                {!!_.find(data.tableData, {transferred: true}) &&
                  <h4 className={'text-danger text-center'}>
                    В реестре есть ПЕРЕСАЖЕННЫЕ билеты! Исправьте перед отправкой клиенту!
                    <br/>Пересаженные билеты окрашены красным
                  </h4>}
                <div id="printarea" className={'register'}>
                  <style type="text/css" media="print">
                    {" @page { size: landscape; } "}
                  </style>
                  <SaleTable editbleArray={data}
                             showCol={showCol}
                             setShowCol={setShowCol}
                             setEditableArray={setData}
                             edit={edit}
                             onReload={options ? () => getValues(options, true) : undefined}/>
                  <div className={'d-flex justify-content-between align-items-center'}>
                    <h4>
                      Итого: <b>{numberFormat(_.sumBy(data.tableData.tableData, 'total'))} KZT</b>
                    </h4>
                    <Button type={"button"}
                            variant={'outline-primary'}
                            size={'sm'}
                            className={'notVisible'}
                            onClick={addKaspiFee}>
                      +1%
                    </Button>
                  </div>

                </div>
                {data.payments ? <PaymentsTable
                  editbleArray={data}
                  setEditableArray={setData}/> : "Подгружаем список оплат..."}
                <button type={"button"}
                        className={'btn btn-outline-primary'}
                        onClick={() => setAddRowsOpen(true)}>
                  Добавить дополнительные строки
                </button>
                <br/>

                <AccountedRecordsRow accountedRecords={data.tableData.accountedRecords}/>
                <AccountedRecordsRow cl={'text-danger'} accountedRecords={data.tableData.unaccountedRecords}
                                     title={'Неучтенные записи:'}/>
                <div className={'position-relative mt-3'}>
                  <label className={'absolutLabel'}>Коментарий</label>
                  <Form.Control
                    as="textarea"
                    rows="2"
                    value={description}
                    onChange={newVal => setDescription(newVal.target.value)}
                  />
                </div>

              </> :
              <div>Задайте параметры и сформируйте таблицу</div>}
          </BlockUi>
        </PortletBody>
        {data &&
          <PortletFooter>
            <LoadingButton
              title={"Сохранить таблицу"}
              type={'button'}
              onClick={()=>saveRegister(false)}
              disabled={saving || data.isDeleted === true}
              loading={saving}
            />
          </PortletFooter>}
      </Portlet>
      {addRowsOpen && <AddRowsModal show
                                    onHide={() => setAddRowsOpen(false)}
                                    buyerId={buyerId || dataBase?.buyerId || options?.buyerId}
                                    excludeId={edit && id ? id : undefined}
                                    existingIdentifiers={(data?.tableData?.tableData || []).map(row => row.identifier).filter(Boolean)}
                                    onAdd={addExtraRows}/>}

    </div>
  );
};

export default SaleRegister;
